import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { withStyles } from '@material-ui/core/styles'
import { SvgIcon } from '@material-ui/core'
import {
  mdiAlert,
  mdiAlertCircle,
  mdiCheckCircle,
} from '@mdi/js'

class StatusIcon extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    status: PropTypes.string.isRequired,
    className: PropTypes.string,
    size: PropTypes.number,
  }

  static defaultProps = {
    className: null,
    size: null,
  }

  static styles = (theme) => ({
    ok: {
      color: theme.status.ok.color,
    },
    warning: {
      color: theme.status.warning.color,
    },
    error: {
      color: theme.status.error.color,
    },
    size60: {
      width: 60,
      height: 60,
    },
  })

  render() {
    const {
      status, classes, className, size, ...props
    } = this.props

    // Can't yet dynamically set styles, for now use custom class
    // https://github.com/mui-org/material-ui/issues/7633
    let clNames = classNames(className, classes[status])
    if (size === 60) {
      clNames = classNames(clNames, classes.size60)
    }

    switch (status) {
      case 'ok':
        return <SvgIcon {...props} className={clNames}><path d={mdiCheckCircle} /></SvgIcon>
      case 'warning':
        return <SvgIcon {...props} className={clNames}><path d={mdiAlert} /></SvgIcon>
      case 'error':
        return <SvgIcon {...props} className={clNames}><path d={mdiAlertCircle} /></SvgIcon>
      default:
        return null
    }
  }
}

export default withStyles(StatusIcon.styles)(StatusIcon)
